import React, { PureComponent } from 'react';
import { Alert, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faThumbsUp,
  faExclamationCircle,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import './Alert.scss';

export default class AlertComponent extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    icon: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.element.isRequired,
  };

  static defaultProps = {
    color: '',
    icon: false,
    className: '',
  };

  constructor() {
    super();

    this.state = {
      visible: true,
    };
  }

  onShow = () => {
    this.setState({ visible: true });
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    const { color, className, icon, children } = this.props;
    let Icon;

    switch (color) {
      case 'info':
        Icon = <FontAwesomeIcon icon={faInfoCircle} />;
        break;
      case 'success':
        Icon = <FontAwesomeIcon icon={faThumbsUp} />;
        break;
      case 'warning':
        Icon = <FontAwesomeIcon icon={faExclamationCircle} />;
        break;
      case 'danger':
        Icon = <FontAwesomeIcon icon={faExclamationTriangle} />;
        break;
      default:
        break;
    }

    if (this.state.visible) {
      return (
        <Alert color={color} className={className} isOpen={this.state.visible}>
          {icon && <div className="alert__icon">{Icon}</div>}
          <div className="alert__content">{children}</div>
          <button className="close" onClick={this.onDismiss}>
            <span className="lnr lnr-cross" />
          </button>
        </Alert>
      );
    }

    return <React.Fragment />;
  }
}
